/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_4_QInputs */

const en_mk_faq_4_q = /** @type {(inputs: Mk_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can an agent send messages or post without my permission?`)
};

const id_mk_faq_4_q = /** @type {(inputs: Mk_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisakah agen mengirim pesan atau posting tanpa izin saya?`)
};

/**
* | output |
* | --- |
* | "Can an agent send messages or post without my permission?" |
*
* @param {Mk_Faq_4_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_4_q = /** @type {((inputs?: Mk_Faq_4_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_4_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_4_q(inputs)
	return en_mk_faq_4_q(inputs)
});